export const ADMIN_LIST = [
  'geonsang.jo@wantedlab.com',
  'gayoung.han@wantedlab.com',
  'seongae.kim@wantedlab.com',
  'seokmo.gu@wantedlab.com',
  'minjeong.kang@wantedlab.com',
  'minjae.kim@wantedlab.com',
  'junho.park@wantedlab.com',
  'poollip@wantedlab.com',
  'bonghoon@wantedlab.com',
  'sangin@wantedlab.com',
  'seunghoon@wantedlab.com',
  'jisun.han@wantedlab.com',
  'kibaek.kim@wantedlab.com',
];
